import { Box } from '@mui/material';
import React from 'react';
import { InvoiceViewTotals } from './InvoiceViewTotals';
import { InvoiceViewAutopay } from './InvoiceViewAutopayOrLink';
import styles from './InvoiceViewTotalsAndAutoPay.module.scss';
import { gql, DocumentNode } from '@apollo/client';
import { InvoiceViewTotalsAndAutopayInvoiceFragment } from '#types';

const invoiceViewTotalsAndAutopayInvoiceFragment = gql`
	fragment invoiceViewTotalsAndAutopayInvoice on Invoice {
		...invoiceViewAutopayInvoice
		...invoiceViewTotalsInvoice
	}
	${ InvoiceViewAutopay.fragments.invoiceViewAutopayInvoiceFragment }
	${ InvoiceViewTotals.fragments.invoiceViewTotalsInvoiceFragment }
`;

export type InvoiceViewTotalsAndAutoPayProps = {
	invoice?: InvoiceViewTotalsAndAutopayInvoiceFragment;
	requestingUserBaseId?: string;
	guestToken?: string;
};

type InvoiceViewTotalsAndAutoPayPropsWithFragment =
	React.FC<InvoiceViewTotalsAndAutoPayProps> & {
		fragments: {
			invoiceViewTotalsAndAutopayInvoiceFragment: DocumentNode;
		};
	};

export const InvoiceViewTotalsAndAutoPay: InvoiceViewTotalsAndAutoPayPropsWithFragment =
	( { invoice, requestingUserBaseId, guestToken } ) => {
		return (
			<Box className={ styles.container }>
				<InvoiceViewAutopay
					invoice={ invoice }
					requestingUserBaseId={ requestingUserBaseId }
					guestToken={ guestToken }
				/>
				<InvoiceViewTotals
					invoice={ invoice }
					requestingUserBaseId={ requestingUserBaseId }
				/>
			</Box>
		);
	};

InvoiceViewTotalsAndAutoPay.fragments = {
	invoiceViewTotalsAndAutopayInvoiceFragment,
};
